<template>
	<div id="bottomPanel">
		<!-- <transition name="fade-angle-panel"> -->
		<!-- v-if="isAnglePanelVisible" -->
		<div id="anglePanel">
			<img title="Rotate -90" src="images/projections/-90.png" class="angle-button"
				v-on:click="rotateByAngle($event, -90)" />
			<img title="Rotate -45" src="images/projections/-45.png" class="angle-button"
				v-on:click="rotateByAngle($event, -45)" />
			<img title="Rotate 0" src="images/projections/0.png" class="angle-button"
				v-on:click="rotateByAngle($event, 0)" />
			<img title="Rotate 45" src="images/projections/45.png" class="angle-button"
				v-on:click="rotateByAngle($event, 45)" />
			<img title="Rotate 90" src="images/projections/90.png" class="angle-button"
				v-on:click="rotateByAngle($event, 90)" />
			<img title="Rotate 180" src="images/projections/180.png" class="angle-button"
				v-on:click="rotateByAngle($event, 180)" />
		</div>
		<!-- </transition> -->
		<img id="resetImg" title="Reset View" class="stl-button"
			:src="isWhite ? 'images/reset_blue.png' : 'images/reset.png'" v-on:click="reset($event)" />
		<img id="globalResetImg" title="Global Reset" class="stl-button"
			:src="isWhite ? 'images/globalReset_blue.png' : 'images/globalReset1.png'"
			v-on:click="globalReset($event)" />
		<img id="rotateImg" title="Rotate View" class="stl-button"
			:src="isWhite ? 'images/rotate_blue.png' : 'images/rotate.png'" v-on:click="switchAutoRotate($event);" />
		<img id="anglePanelImg" title="Rotate By Angle" class="stl-button"
			:src="isWhite ? 'images/angle_blue.png' : 'images/angle_icon.png'" v-on:click="toggleAnglePanel($event)" />
		<img id="clipImg" title="Clip Scene" class="stl-button"
			:src="isWhite ? 'images/clip_blue.png' : 'images/clip_icon.png'" v-on:click="showClipDialog($event)" />
		<img id="measureImg" title="Measure" class="stl-button"
			:src="isWhite ? 'images/measure_blue.png' : 'images/measure_white.png'"
			v-on:click="enterMeasureModeClick($event)" />

		<div id="airwayBottomDiv" v-if="airways.length" class="stl-button">
			<img id="airwayBottomImg" :title="airwayMessage ? airwayMessage : 'Airway Mode'" class="stl-button"
				:src="isWhite ? 'images/airway_blue.png' : 'images/airway_white.png'"
				v-on:click="enterAirwayModeClick($event)" />
			<img id="airwayBottomProgressImg" v-show="airwayMessage"
				:src="isWhite ? 'images/dark-blue-spinner.gif' : 'images/Spinner-2.1s-200px.gif'" />
		</div>

		<img v-if="allowDownloads" id="saveReportImg" title="Save File" class="stl-button"
			:src="isWhite ? 'images/download_blue.png' : 'images/download_white.png'"
			v-on:click="showReportsDialog($event)" />
		<img v-if="!isViewMode && allowDownloads" id="exportImg" title="Export" class="stl-button"
			:src="isWhite ? 'images/export_blue.png' : 'images/export_white.png'"
			v-on:click="showExportDialogClick($event)" />
		<img id="snapshotImg" title="Snapshot" class="stl-button"
			:src="isWhite ? 'images/snapshot_blue.png' : 'images/snapshot_white.png'"
			v-on:click="snapshotClick($event)" />
	</div>
</template>

<script>
import swal from "sweetalert";
import { degreesToRadians } from "@/components/geometry/geometry.js";
import { MeasureMode, enterMeasureMode, leaveMeasureMode } from "@/components/measure/MeasureMode.js";
import { showClipDialog } from "@/components/reports/ClipDialog.vue";
import { showExportDialog, makeSnapshot } from "@/components/reports/ReportsManager";
import { resetTeeth, resetAll } from "@/components/appStart/resetHelper";
import {
	AirwayMode,
	enterAirwayMode,
	leaveAirwayMode,
} from "@/components/airway/AirwayMode";
import { generateCrossBiteReport } from "@/components/reports/CrossBiteManager.js";

export default {
	name: "BottomPanel",
	props:
		[
			"fromShareLink",
			"isViewMode",
			"allowDownloads",
			"isWhite",
			"airways",
			"airwayMessage"
		],
	data() {
		return {
			isAnglePanelVisible: false
		};
	},
	methods: {
		bottomPanelClick: function (event, parameter) {
			if (event && event.srcElement && event.srcElement.title) {
				let eventTitle = `Bottom->${event.srcElement.title}`;
				// if(parameter) {
				// 	eventTitle += `->${parameter}`;
				// }
				gtag('event', eventTitle);
			}
		},
		switchAutoRotate: function (event) {
			this.bottomPanelClick(event, !vueApp.isAutoRotated);
			if (vueApp.isAutoRotated) {
				viewer.set_auto_rotate(false);
				vueApp.isAutoRotated = false;
			} else {
				viewer.set_auto_rotate(true);
				vueApp.isAutoRotated = true;
				if (event) event.stopPropagation();
			}
		},
		enterMeasureModeClick: function (event) {
			this.bottomPanelClick(event, !MeasureMode.isActive);
			if (MeasureMode.isActive) {
				leaveMeasureMode();
			} else {
				enterMeasureMode();
			}
		},
		enterAirwayModeClick: function (event) {
			this.bottomPanelClick(event);
			if (!AirwayMode.isActive)
				enterAirwayMode();
			else
				leaveAirwayMode();
		},
		globalReset: function (event) {
			// generateCrossBiteReport();
			// return;
			this.bottomPanelClick(event);
			let geometryResetChecked = false;
			swal({
				text: "All changes will be lost. Are you sure?",
				buttons: {
					yes: { text: "Yes", value: true },
					no: { text: "No", value: false }
				}
			}).then(willDelete => {
				if (willDelete) {
					resetAll(geometryResetChecked);
				}
			});
			// var $swalCheckbox = $(
			// 	`<div class='swal-checkbox-div'>
			// 		<input class='swal-checkbox-cb' type='checkbox' id='swalCheckbox'/> 
			// 		<label class='swal-checkbox-lb' for='swalCheckbox'>Reset all objects geometry</label>
			// 	</div>`
			// );
			// $(".swal-footer").append($swalCheckbox);
			// $("#swalCheckbox").change(() => {
			// 	geometryResetChecked = $("#swalCheckbox").is(":checked");
			// 	// let checked = document.querySelector('#swalCheckbox').checked;
			// 	console.log("swal-checkbox ", geometryResetChecked);
			// });
		},
		reset: function (event) {
			this.bottomPanelClick(event);
			resetView();
			resetTeeth(false);
		},
		toggleAnglePanel: function (event) {
			var isVisible = $("#anglePanel").css("display") != "none";
			this.bottomPanelClick(event, !isVisible);
			if (isVisible) {
				$("#anglePanel").fadeOut(); // .fadeOut(500) slideUp
			} else {
				// console.log("#anglePanel show");
				if (vueApp.isOcclusal)
					vueApp.leaveModes(false);
				$("#anglePanel").slideDown();
			}
		},
		rotateByAngle: function (event, angle) {
			this.bottomPanelClick(event);
			vueApp.lookAtPoint({ x: 0, y: 0, z: 0 });

			let activeMode = vueApp.activeMode;
			let vcenter = activeMode ? activeMode.vcenter : null;
			console.log("rotateByAngle", activeMode, vcenter);
			if (vcenter)
				vcenter = vueApp.lookAtPoint(vcenter);

			resetCameraUp();

			viewer.camera.position.x = 0;
			viewer.camera.position.y = 0;
			viewer.camera.position.z = vcenter ? vcenter.z : defaultZoom;
			viewer.camera.position.applyQuaternion(
				new THREE.Quaternion().setFromAxisAngle(
					new THREE.Vector3(0, 1, 0), // The positive y-axis
					degreesToRadians(angle) // The amount of rotation to apply this time
				)
			);

			viewer.camera.updateProjectionMatrix();
			viewer.controls.update();
			viewer.controls.dispatchChangeAfterDelay(100);
		},
		showClipDialog: function (event) {
			this.bottomPanelClick(event);
			showClipDialog();
		},
		showExportDialogClick: function (event) {
			this.bottomPanelClick(event);
			showExportDialog();
		},
		snapshotClick: function (event) {
			this.bottomPanelClick(event);
			makeSnapshot();
		},
		showReportsDialog: function (event) {
			this.bottomPanelClick(event);
			$("#hintGetReport").html("Press button to get file");
			$("#reportsDialog").modal();
		}
	},
	mounted: function () {
		var stl_cont = document.getElementById("stl_cont");
		stl_cont.addEventListener("mouseup", viewerMouseUp, false);
	}
};

//#region AutoRotate

function viewerMouseUp() {
	viewer.controls.noRotate = false; // 3.2
	if (vueApp.isAutoRotated) {
		viewer.set_auto_rotate(false);
		vueApp.isAutoRotated = false;
	}
}

//#endregion

</script>

<style>
.fade-angle-panel-enter-active,
.fade-angle-panel-leave-active {
	transition: all 0.5s;
}

.fade-angle-panel-enter,
.fade-angle-panel-leave-to {
	transform: translateY(20px);
	opacity: 0;
}

#bottomPanel {
	width: 440px;
	position: absolute;
	left: calc(50% - 205px);
	bottom: 18px;
	z-index: 999;
	/* display: none; */
}

/* @media (max-width: 430px) {
	#bottomPanel {
		left: calc(50% - 180px);
	}
} */

.stl-button {
	/*position: absolute;*/
	/*right: 15px;*/
	width: 30px;
	height: 30px;
	margin-left: 16px;
	cursor: pointer;
}

#airwayBottomDiv {
	height: 27px;
	width: auto;
	margin-top: 0;
	margin-left: 14px;
	display: inline;
}

#airwayBottomImg {
	margin-top: 0;
	margin-left: 0;
	height: 27px;
	width: 27px;
}

#airwayBottomProgressImg {
	margin-top: -12px;
	height: 27px;
	width: 27px;
	margin-left: -7px;
	margin-right: -14px;
}

#saveReportImg {
	height: 25px;
	width: 25px;
}

#exportImg {
	height: 27px;
	width: 27px;
	margin-top: 2px;
	margin-left: 15px;
}

#snapshotImg {
	height: 29px;
	width: 29px;
	margin-top: 4px;
	margin-left: 10px;
}

#clipImg,
#measureImg {
	height: 27px;
	width: 27px;
}

#anglePanel {
	text-align: left;
	font-weight: bold;
	color: white;
	font-family: Montserrat, sans-serif;
	display: none;
	margin-left: 72px;
	margin-bottom: 10px;
}

.angle-button {
	width: 30px;
	height: 30px;
	margin-left: 8px;
	text-align: right;
	cursor: pointer;
}

.swal-modal {
	/*background-color: rgba(63,255,106,0.69);
		border: 3px solid white;*/
	border-radius: 0;
}

.swal-button {
	border-radius: 0;
	background-color: #4687fc;
	/*border: 1px solid #3e549a;*/
}

/* .snap-dg{
	background-color: white;
} */

.snap-dg .swal-footer {
	text-align: left;
}
</style>
